import React from 'react';

export interface ILanguageContext {
  // eslint-disable-next-line
  messages?: any;
  defaultLanguage?: string;
  currentLanguage?: string;
  changeLanguage?: (language: string) => void;
  getTranslation?: (key: string) => string;
}

export const LanguageContext = React.createContext<ILanguageContext>({
  defaultLanguage: 'en',
});
